import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";

// Mixins / Modules
import isResizable from "../../../../../mixins/resizable";

class Calendar extends React.Component {
  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
  }

  componentDidMount() {
    this.loadHubSpotScript();
  }

  componentDidUpdate() {
    // Reload the script when component updates
    this.loadHubSpotScript();
  }

  loadHubSpotScript() {
    // Remove the existing script if it exists
    const existingScript = document.querySelector(
      'script[src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"]'
    );
    if (existingScript) {
      existingScript.remove();
    }

    // Create and append a fresh script
    const script = document.createElement("script");
    script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
    script.type = "text/javascript";
    script.async = true;
    script.onload = () => {
      // Ensure initialization after the script is loaded
      if (window.HubSpotMeetings) {
        const meetingsContainers = document.querySelectorAll(
          ".meetings-iframe-container"
        );
        meetingsContainers.forEach((container) => {
          container.innerHTML = ""; // Clear previous content
          const iframe = document.createElement("iframe");
          iframe.src = container.getAttribute("data-src");
          iframe.width = "100%";
          iframe.height = "100%";
          iframe.style.border = "none";
          container.appendChild(iframe);
        });
      }
    };
    document.body.appendChild(script);
  }

  render() {
    const { isMobile } = this.props;

    return (
      <div>
        <div
          className={classNames("meetings-iframe-container", {
            'width-635': !isMobile,
            'width-560': isMobile,
          })}
          data-src="https://oomple.com/meetings/sarah-powers/oomple-demo?embed=true"
        ></div>
      </div>
    );
  }
};

export default isResizable(Calendar);